<template>
  <el-dialog
    :visible="visible"
    width="1060px"
    top="5vh"
    @close="handleClose"
    :close-on-click-modal="false"
    destroy-on-close
  >
    <template slot="title">
      <div class="titleSlot">
        <div class="line"></div>
        <div class="titleText">
          <p>选择积分数量</p>
        </div>
      </div>
    </template>
    <div class="design-points-container">
      <div class="top-section">
        <div class="points-cards">
          <div
            v-for="(card, index) in pointsCards"
            :key="index"
            class="points-card"
            :class="{ active: card.active }"
            @click="selectCard(index, card)"
          >
            <div class="gift" v-if="card.isFirstRecharged === 0">
              首充双倍 +{{ Math.floor(card.firstGiftPoints) }}积分
            </div>
            <div class="gift" v-else>加赠 +{{ card.giftPoints }}积分</div>
            <div class="points-value">
              <span class="value">{{ card.rechargePoints }}</span>
              <span class="unit">积分</span>
            </div>
            <div class="price">¥{{ card.rechargeAmount.toFixed(2) }}</div>
          </div>
        </div>
      </div>

      <div class="orderpay">
        <div class="line"></div>
        <div class="title">支付订单</div>
      </div>
      <div>
        <div class="pay-dialog">
          <div class="pay-info">
            <div class="pay-code-container">
              <el-image
                class="pay-code"
                :src="qrCodeData"
                v-loading="isAgreed && qrCodeData === qrDefault"
              ></el-image>
              <div v-if="!isAgreed" class="pay-code-mask">
                <div class="mask-text">
                  请先阅读并同意<br />
                  下方支付协议
                </div>
                <div class="mask-btn" @click="isAgreed = true">已阅读并同意</div>
              </div>
            </div>
            <div class="pay-content">
              <div class="pay-title" style="display: flex">
                <div class="text">订单编号:</div>
                <div class="payOrder">
                  {{ selectCardInfo.orderNo }}
                </div>
              </div>
              <div class="pay-title">
                支付金额：<span class="pay-radio">¥</span>
                <span class="pay-value">{{
                  selectCardInfo.rechargeAmount.toFixed(2)
                }}</span>
              </div>
              <p class="pay-method-title pay-title">微信或支付宝扫码支付</p>
              <div class="pay-method">
                <el-image class="wxpay-icon" :src="wxpay"></el-image>
                <el-image class="alipay-icon" :src="alipay"></el-image>
              </div>
              <div class="pay-agreement">
                <el-checkbox v-model="isAgreed" class="agreement-checkbox"></el-checkbox>
                支付前请阅读
                <el-link type="primary" :underline="false" @click="goAgreement"
                  >《支付协议》</el-link
                >
              </div>
            </div>
          </div>

          <div class="pay-btns">
            <el-button class="cancel-btn" @click="cancelPay"
              >取消支付</el-button
            >
            <el-button class="confirm-btn" type="primary" @click="confirmPay"
              >我已支付</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  requestPointsProductList,
  createPointsOrder,
  queryPointsOrderStatus,
} from "@/api/merchant";
import wxpay from "@/assets/images/wxpay.png";
import alipay from "@/assets/images/alipay.png";
import qrDefault from "@/assets/images/pic-qrcode-default.png";
import QRCode from "qrcode";

export default {
  name: "MyDesignPoints",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pointsCards: [],
      wxpay: wxpay,
      alipay: alipay,
      qrDefault: qrDefault,
      selectCardInfo: {
        rechargeAmount: 0,
      },
      qrCodeData: qrDefault,
      orderId: null,
      isAgreed: false,
    };
  },
  watch: {
    visible(newVal) {
      this.getPointsProductList();
      if (!newVal) {
        setTimeout(() => {
          this.qrCodeData = this.qrDefault;
        }, 500);
      }
    },
    isAgreed(newVal) {
      if (newVal && this.selectCardInfo && this.selectCardInfo.id) {
        this.buyPoints(this.selectCardInfo);
      }
    },
  },
  methods: {
    selectCard(index, card) {
      this.pointsCards.forEach((card, i) => {
        card.active = i === index;
      });
      this.buyPoints(card);
    },
    buyPoints(card) {
      this.selectCardInfo = card;
      if (!this.isAgreed) {
        this.qrCodeData = this.qrDefault;
        return;
      }
      createPointsOrder({
        productId: card.id,
        rechargeAmount: card.rechargeAmount,
        rechargePoints: card.rechargePoints,
        giftPoints:
          card.isFirstRecharged === 0 ? card.firstGiftPoints : card.giftPoints,
      }).then((res) => {
        this.orderId = res.data.orderId;
        this.selectCardInfo.orderNo = res.data.orderNo;
        this.generateQRCode(res.data.qrCode);
      });
    },
    async getPointsProductList() {
      try {
        const res = await requestPointsProductList({});
        if (res.data) {
          if (res.data.products && res.data.products.length > 0) {
            this.pointsCards = res.data.products

              .sort((a, b) => (a.sort || 0) - (b.sort || 0))
              .map((product, index) => ({
                ...product,
                active: index === 0,
              }));
          }
          if (this.visible && this.pointsCards.length > 0) {
            this.selectCard(0, this.pointsCards[0]);
          }
        }
      } catch (error) {
        console.error("获取积分产品列表失败:", error);
      }
    },
    cancelPay() {
      // cancelPointsOrder({ id: this.orderId }).then(() => {
      // 取消订单接口先不调用了，直接关闭弹窗
        this.handleClose();
      // });
    },
    confirmPay() {
      queryPointsOrderStatus({ id: this.orderId }).then((res) => {
        // this.$message({
        //   message: "支付成功",
        //   type: "success",
        //   duration: 3 * 1000,
        // });
        this.handleClose();
      });
    },
    goAgreement() {
      const route = this.$router.resolve({
        path: "/design/agreement",
      });
      window.open(route.href, "_blank");
    },
    async generateQRCode(url) {
      try {
        this.qrCodeData = await QRCode.toDataURL(url, {
          width: 200,
          margin: 2,
        });
      } catch (err) {
        console.error(err);
      }
    },
    handleClose() {
      this.isAgreed = false;
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.design-points-container {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 15px;
  box-sizing: border-box;
  height: 100%;
  position: relative;
  // overflow-y: scroll;

  .top-section {
    margin-bottom: 40px;
  }

  .points-cards {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 16px;
    row-gap: 16px;
    height: auto;
    overflow-y: auto;

    .points-card {
      position: relative;
      height: 156px;
      background: #f3f9ff;
      border: 1px solid #d6e8ff;
      border-radius: 10px;
      padding: 36px 0 0;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      box-sizing: border-box;

      &.active {
        border-color: #0090ff;
        box-shadow: 0 0 0 1px #0090ff;
      }

      &:hover {
        border-color: #0090ff;
      }

      .gift {
        position: absolute;
        top: 10px;
        left: -4px;
        height: 26px;
        padding: 0 14px 0 12px;
        background: #ff8a00;
        color: #fff;
        font-size: 13px;
        font-weight: 700;
        line-height: 26px;
        border-radius: 2px 2px 2px 0;

        &::after {
          content: "";
          position: absolute;
          right: -8px;
          top: 0;
          border-top: 13px solid transparent;
          border-bottom: 13px solid transparent;
          border-left: 8px solid #ff8a00;
        }
      }

      .points-value {
        display: flex;
        align-items: baseline;
        margin-top: 18px;
        color: #0090ff;

        .value {
          font-size: 36px;
          font-weight: 800;
          line-height: 1;
          font-style: italic;
        }

        .unit {
          margin-left: 4px;
          font-size: 14px;
          font-weight: 700;
        }
      }

      .price {
        margin-top: auto;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        font-weight: 700;
        color: #fff;
        background: #00c2b3;
      }
    }
  }
}

.records-container {
  width: 100%;

  .text-danger {
    color: #f56c6c;
    text-align: left;
  }

  .text-success {
    color: #67c23a;
    text-align: left;
  }

  ::v-deep .el-table {
    border-radius: 8px;
    overflow: hidden;

    .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
        font-weight: 600;
        color: #333;
        padding: 12px 0;
      }
    }

    .el-table__body-wrapper {
      td {
        padding: 12px 0;
      }
    }

    .el-table__row:hover {
      background-color: #f0f2ff;
    }
  }

  ::v-deep .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .el-pagination {
      padding: 0;
      margin: 0;

      .btn-prev,
      .btn-next,
      .number {
        background: #fff;
        border-radius: 4px;
        margin: 0 4px;
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        border: 1px solid #e4e7ed;
      }

      .active {
        background-color: #6236ff;
        color: #fff;
        border-color: #6236ff;
      }
    }
  }
}

.titleSlot {
  display: flex;
  .line {
    width: 4px;
    height: 20px;
    background: #0090ff;
    border-radius: 2px;
    margin-right: 10px;
  }
  .titleText {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 18px;
    color: #303133;
  }
  img {
    width: 21px;
    height: 17px;
  }
  .tips {
    color: #ff7481;
  }
}

.orderpay {
  display: flex;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
  .line {
    width: 4px;
    height: 20px;
    background: #0090ff;
    border-radius: 2px;
    margin-right: 10px;
  }
  .title {
    font-weight: 500;
    font-size: 18px;
    color: #606266;
  }
}
</style>
<style lang="scss">
.pay-dialog {
  .el-dialog__body {
    padding: 0 40px;
  }

  ::v-deep .el-dialog {
    border-radius: 16px;
  }

  .pay-info {
    padding: 24px;
    box-sizing: border-box;
    background-color: rgba(58, 50, 72, 1);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .pay-code-container {
      position: relative;
      width: 180px;
      height: 180px;
      flex-shrink: 0;

      .pay-code {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }

      .pay-code-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        z-index: 10;
        padding: 10px;
        box-sizing: border-box;

        .mask-text {
          color: #fff;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          margin-bottom: 12px;
          font-weight: bold;
        }

        .mask-btn {
          background: linear-gradient(90deg, #0090ff, #00d1bb);
          color: #fff;
          width: 140px;
          height: 36px;
          line-height: 36px;
          border-radius: 18px;
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          font-weight: bold;
          transition: all 0.3s;

          &:hover {
            opacity: 0.9;
            transform: scale(1.05);
          }
        }
      }
    }

    .pay-content {
      font-family: Microsoft YaHei UI;
      margin-left: 40px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .pay-title {
        font-weight: bold;
        font-size: 14px;
        color: #a0a9b0;
        margin-bottom: 0px;
      }

      .pay-radio {
        font-size: 20px;
        color: #ffffff;
      }

      .pay-value {
        font-size: 32px;
        color: #ffffff;
      }

      .pay-method {
        margin-bottom: 20px;

        .wxpay-icon {
          margin-right: 10px;
          width: 36px;
          height: 36px;
        }

        .alipay-icon {
          width: 36px;
          height: 36px;
        }
      }

      .pay-method-title {
        font-size: 14px;
        color: #ffffff;
        line-height: 28px;
      }
    }

    .pay-agreement {
      display: flex;
      align-items: center;
      font-family: Microsoft YaHei UI;
      font-weight: 400;
      font-size: 14px;
      color: #a6a1b0;

      .agreement-checkbox {
        margin-right: 8px;
        ::v-deep .el-checkbox__inner {
          border-radius: 4px;
        }
      }
    }
  }

  .pay-desc {
    font-family: Microsoft YaHei UI;
    font-size: 14px;
    color: #666666;
    padding: 20px;
    box-sizing: border-box;

    .pay-desc-title {
      font-family: Microsoft YaHei UI;
      font-weight: bold;
      font-size: 14px;
      color: #666666;
    }
  }

  .pay-btns {
    border-top: 1px solid #e4e7ed;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    .cancel-btn {
      width: 120px;
      height: 40px;
      background: #ffffff;
      border-radius: 20px;
      border: 1px solid #cccccc;
    }
    .confirm-btn {
      width: 120px;
      height: 40px;
      background: linear-gradient(90deg, #0090ff, #00d1bb);
      border-radius: 20px;
    }
  }
}
</style>
